import { AxiosAdapter, AxiosRequestConfig } from "axios";

export const mockPermitido = (ambiente?: string, flag?: string): boolean =>
  flag === "true" && ambiente === "development";

const flagMock = process.env.REACT_APP_MOCK_API === "true";

export const mockApiAtivo = mockPermitido(process.env.NODE_ENV, process.env.REACT_APP_MOCK_API);

if (flagMock && !mockApiAtivo) {
  // eslint-disable-next-line no-console
  console.error("REACT_APP_MOCK_API ignorado: o mock so vale em build de desenvolvimento.");
} else if (mockApiAtivo) {
  // eslint-disable-next-line no-console
  console.warn("ConciliadorApi em modo MOCK: os dados exibidos nao vem do banco.");
}

export const adapterMockSobDemanda = (): AxiosAdapter => {
  const carregado = import("./apiMock").then((modulo) => modulo.mockAdapter);
  return (config: AxiosRequestConfig) => carregado.then((adapter) => adapter(config));
};
